"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _index = _interopRequireDefault(require("../Logo/index"));
var _index2 = _interopRequireDefault(require("./index.style"));
const Loader = _ref => {
  let {
    open = false
  } = _ref;
  const classes = (0, _index2.default)();
  return /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
    className: classes.backdrop,
    open: open
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    className: classes.circularLoader,
    size: "120px",
    thickness: 1
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    className: classes.loaderLogo,
    color: "#001871",
    width: "42px",
    height: "42px"
  }));
};
var _default = exports.default = Loader;